import { render, staticRenderFns } from "./VehicleContractsWidget.vue?vue&type=template&id=244c68ae&scoped=true&"
import script from "./VehicleContractsWidget.vue?vue&type=script&lang=js&"
export * from "./VehicleContractsWidget.vue?vue&type=script&lang=js&"
import style0 from "./VehicleContractsWidget.vue?vue&type=style&index=0&id=244c68ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c68ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244c68ae')) {
      api.createRecord('244c68ae', component.options)
    } else {
      api.reload('244c68ae', component.options)
    }
    module.hot.accept("./VehicleContractsWidget.vue?vue&type=template&id=244c68ae&scoped=true&", function () {
      api.rerender('244c68ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleContractsWidget.vue"
export default component.exports